import { PAConstants } from 'wmic-pe-portals-utils-js';

const getExistingEndorsements = (driverEndorsement, driverPublicId, paLobDataVM) => {
    let driverEndorsements = [];

    if (driverEndorsement.publicID === PAConstants.reducAmtForNamedCov_28A_PublicId) {
        driverEndorsements = paLobDataVM?.endorsements_Ext?.excludedDriverEndorsements_WMIC?.children;
    } else if (driverEndorsement.publicID === PAConstants.reducAmtForNamedCov_28_PublicId) {
        driverEndorsements = paLobDataVM?.endorsements_Ext?.reductionDriverEndorsements_WMIC?.children;
    }

    return driverEndorsements?.filter(endorsement => endorsement.driverPublicID.value === driverPublicId);
};

const shouldShowCheckboxDetailStyle = (driverEndorsementPublicID, checked) =>
    checked &&
    [PAConstants.reducAmtForNamedCov_28A_PublicId, PAConstants.reducAmtForNamedCov_28_PublicId].includes(
        driverEndorsementPublicID
    );

export default {
    getExistingEndorsements,
    shouldShowCheckboxDetailStyle,
};
